export const GLOBAL_PULSE_TOUR_STYLE_ID = 'go-pulse-tour-style-id';
export const GLOBAL_PULSE_TOUR_CLASSES = {
	PULSE: 'go-pulse-tour-pulse',
	BADGE: 'go-pulse-tour-new-badge',
	ANIMATION: 'go-pulse-tour-animation'
} as const;
